module.exports = __webpack_public_path__ + "static/media/297566.9fa8cfa8.png";